import { TableCell } from '@/components/Datatable/TableCell';
import { IDatatableData } from '@/type/listing.types';
import { FieldValues } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from '@/components/Controls/Checkbox';
import { TableHeaderActions } from '@/components/Custom/Datatable/TableHeaderActions';
import { useSelectedTableItems } from '@/hooks/selected-table-items.hooks';
import { getFormattedDate, getFormattedTime } from '@/utils/date.utils';
import { TableMenu } from '@/components/Menu/TableMenu';
import { SubMenuItem } from '@/components/Menu/SubMenuItem';

export const VehiculeCheckEmailTableData = <TSchema extends FieldValues>({
  t,
  data,
  onDeactivate,
}: IDatatableData<TSchema>) => {
  const navigate = useNavigate();

  const { numberOfItemsText, selectedTableData, onSelectedItem } =
    useSelectedTableItems({
      t,
      data,
      onDeactivate,
    });

  if (!data || data.length === 0) {
    return <></>;
  }

  return (
    <>
      {selectedTableData?.length > 0 && (
        <TableHeaderActions
          colSpan={5 + 1}
          text={numberOfItemsText}
          disableDeactivate={selectedTableData?.every((item) => !item?.active)}
          disableDownload
          onDownload={() => {}}
          onCreate={() => navigate('/vehicule-check/create')}
        />
      )}
      {data.map((entry: TSchema) => {
        return (
          <tr key={entry?.id}>
            <TableCell
              tdClassName="sticky-select-column"
              content={
                <Checkbox
                  checked={Boolean(
                    selectedTableData?.find((item) => item?.id === entry?.id)
                  )}
                  onChange={() => onSelectedItem(entry?.id)}
                />
              }
            />
            <TableCell
              tdClassName="text-center"
              content={
                <div className="flex flex-col">
                  <div className="flex gap-1.5">
                    <div>
                      <i className="-mt-[5.7px] ki-outline ki-calendar text-lg" />
                    </div>
                    <div>{getFormattedDate(entry?.updatedAt)}</div>
                  </div>
                  <div className="flex gap-1.5">
                    <div>
                      <i className="-mt-[5.7px] ki-outline ki-time text-lg" />
                    </div>
                    <div>{getFormattedTime(entry?.updatedAt)}</div>
                  </div>
                </div>
              }
            />
            <TableCell
              content={
                <div className="flex gap-1.5">
                  <div className="flex justify-center items-center w-5 min-w-5 h-5 min-h-5 rounded bg-black text-2xs text-white uppercase font-bold">
                    {entry?.fromName?.trim()?.charAt(0)}
                  </div>
                  <div>{entry?.fromName}</div>
                </div>
              }
            />
            <TableCell content={entry?.emailSubject} />
            <TableCell
              tdClassName="sticky-action-column"
              content={
                <TableMenu>
                  <SubMenuItem
                    text="Consulter"
                    leftIconClassName="ki-eye !text-[17.5px]"
                    to={`/vehicule-check-email/view/${entry?.id}`}
                  />
                </TableMenu>
              }
            />
          </tr>
        );
      })}
    </>
  );
};
